/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_507Inputs */

const vi_carrier_status_507 = /** @type {(inputs: Carrier_Status_507Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách đến bưu cục nhận`)
};

/**

* @param {Carrier_Status_507Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_507 = /** @type {((inputs?: Carrier_Status_507Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_507Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_507(inputs)
});